import { BetsApiClient } from "./BettingGatewayClient/BetsApiClient";
import { BettingGatewayConfigurations } from "./BettingGatewayConfigurations";
import { AjaxService } from "sb-helpers";
import { GlobalConfig } from "../configuration";
var BettingGateway = /** @class */ (function () {
    function BettingGateway() {
        var config = new BettingGatewayConfigurations({
            accessToken: GlobalConfig
                .getAuthorization()
                .token,
            basePath: GlobalConfig.apiConfigs.betsApiUrl
        });
        var service = new AjaxService();
        this.betsApiClient = new BetsApiClient(config, service);
    }
    BettingGateway.prototype.getGlobalConfigToken = function () {
        return GlobalConfig
            .getAuthorization()
            .token;
    };
    BettingGateway.prototype.placeBets = function (request) {
        return this.betsApiClient
            .refreshToken(this.getGlobalConfigToken())
            .placeBets(request);
    };
    BettingGateway.prototype.calculateBets = function (request) {
        return this.betsApiClient
            .refreshToken(this.getGlobalConfigToken())
            .calculateBets(request);
    };
    BettingGateway.prototype.precalculateBets = function (request) {
        return this.betsApiClient
            .refreshToken(this.getGlobalConfigToken())
            .precalculateBets(request);
    };
    return BettingGateway;
}());
export { BettingGateway };
//# sourceMappingURL=BettingGateway.js.map